import useResource from "./use-resource.js";

export default function useCustomization(profileBailleurId) {
  let url = profileBailleurId
    ? `/profiles/${profileBailleurId}/customization`
    : `/account/customization`;
  const {
    resource: customization,
    error,
    isLoading,
    update,
    mutate,
    axios,
  } = useResource(url);

  async function resetCustomization(fieldsToReset) {
    let newResource;
    await mutate(
      async () => {
        const response = await axios.put(`${url}/reset`, fieldsToReset);
        newResource = response.data;
        return newResource;
      },
      { revalidate: false },
    );
    return newResource;
  }

  async function testSmtp() {
    return await axios.post(`${url}/test-smtp`);
  }

  return {
    customization,
    error,
    isLoading,
    createOrUpdateCustomization: update,
    resetCustomization,
    testSmtp,
  };
}
